exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Loading{text-align:center;color:#777;padding:2em 0;transition:opacity .25s ease-in}.Loading--inline{color:inherit;display:inline;padding:0}.Loading--delaying{visibility:hidden;width:0;height:0;opacity:.01}.Loading--displaying{visibility:visible;height:auto;width:auto;opacity:1}.Loading .glyphicon{font-size:60px;animation:loading-spin 2s infinite linear}.Loading--inline .glyphicon{font-size:.75em}.Loading__text{margin-top:12px}@keyframes loading-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./redux-form-components/components/Loading.css
 ** module id = 220
 ** module chunks = 2
 **/